export default {
  KYC_FAIL_HEADER: "Your identity needs additional verification.",
  KYC_FAIL_SUBHEADINGS: [
    "We've had a problem verifying your identity automatically.",
    "To ensure that your acount is compliance with federal and state laws, we need to speak with you to perform additional verification.",
    "Please reach out to us at support@brightmoney.co to verify your identity and open your account.",
  ],
  KYC_FAIL_BUTTON_HEADING: "Check Status",
};
